var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-wrap"},[_c('div',{staticClass:"banner-list"},[_c('el-carousel',{attrs:{"arrow":"never","height":"650px"}},_vm._l((_vm.list),function(item,index){return _c('el-carousel-item',{key:index},[_c('img',{attrs:{"src":item.img,"alt":item.name},on:{"click":function($event){return _vm.swiperClick(item)}}})])}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }